// aria-labely mobilnej hlavičky — slovenské dvojče locale/cs/mobileHeader.js.
export default {
  menu: 'Menu',
  search: 'Hľadať',
  close: 'Zavrieť',
};
